import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';

// Роут для существующего чек-листа
export const path = '/calculator-tariff/:projectGuid/checklist/:checklistId';
export const getPath = (projectGuid: string, checklistId: number) =>
  `/calculator-tariff/${projectGuid}/checklist/${checklistId}`;

// Роут для создания нового чек-листа
export const newPath = '/calculator-tariff/:projectGuid/checklist/new';
export const getNewPath = (projectGuid: string) => `/calculator-tariff/${projectGuid}/checklist/new`;

const PageChecklist: React.FC = (props) => {
  const Checklist = Loadable.Map({
    loader: {
      page: () => import('./page'),
    },
    loading: LoadableLoading,
    render(loaded) {
      const Page = loaded.page.default;

      return <Page />;
    },
  });

  return <Checklist {...props} />;
};

export default PageChecklist;
